export const RECOMMENDATIONS_EMBED_PATH = '/recommendations/embed';

export const RECOMMENDATIONS_EMBED_MESSAGES = {
  closed: 'beehiiv:recommendations:closed',
  submitted: 'beehiiv:recommendations:submitted',
  redirect: 'beehiiv:recommendations:redirect',
} as const;
